import { createClient, SupabaseClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL
const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Variáveis de ambiente do Supabase não configuradas')
}

const SUPABASE_OPTIONS = {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    storageKey: 'circle-of-life-auth-v1',
  },
  realtime: {
    params: {
      eventsPerSecond: 2,
    },
  },
}

// Cliente singleton — substituído ao voltar da aba
let _client: SupabaseClient = createClient(supabaseUrl, supabaseAnonKey, SUPABASE_OPTIONS)

/**
 * Retorna o cliente Supabase atual.
 * Use esta função em vez de importar `supabase` diretamente nos hooks de dados.
 */
export function getSupabase(): SupabaseClient {
  return _client
}

/**
 * Recria o cliente Supabase do zero, descartando conexões HTTP mortas.
 * Deve ser chamado no visibilitychange quando a aba volta ao foco.
 * O novo cliente lê a sessão do localStorage automaticamente (persistSession: true).
 */
export function recreateSupabaseClient(): SupabaseClient {
  try {
    // Remover canais do cliente antigo antes de descartar
    _client.removeAllChannels()
  } catch (_) {
    // ignora erros de cleanup
  }
  _client = createClient(supabaseUrl!, supabaseAnonKey!, SUPABASE_OPTIONS)
  return _client
}

// Exporta o cliente diretamente para compatibilidade com código existente
// (auth listeners, login page, etc. que importam `supabase` diretamente)
export const supabase = _client

// Listener global de visibilidade — recria o cliente ao voltar da aba
if (typeof window !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      recreateSupabaseClient()
    }
  })
}
